






























































import Vue, { PropType } from 'vue';
import { ReleaseNote } from '@/classes/releaseNote';

export default Vue.extend({
  name: 'ReleaseNoteList',
  props: {
    releases: {
      type: Array as PropType<ReleaseNote[]>,
      required: true,
    },
  },
  methods: {
    formatDate(time: number): string {
      const date = new Date(time);
      const month = `${date.getMonth() + 1}`.padStart(2, '0');
      const day = `${date.getDate()}`.padStart(2, '0');
      return `${date.getFullYear()}/${month}/${day}`;
    },
  },
});
